import styled from '@emotion/styled';

export const Wrapper = styled.div`
margin: 0 auto;
padding-inline: 20px;

@media screen and (min-width: 768px) {
  padding-inline: 32px;
 }

 @media screen and (min-width: 1440px) {
  padding-inline: 128px;
 }
`